import React, { useState, useContext, useEffect } from 'react';

import cookie from 'react-cookies';
import { useNavigate } from 'react-router-dom';

/** components */
import CustomPlaidLink from './CustomPlaidLink';

/** images */
import plaidImg from '../../assets/images/plaid.png';
import TenantConfig from '../../config';

/** context */
import { UserContext } from '../../context/UserContext';

/** service */
import { getPlaidLinkToken } from '../../service/api';
import { ScrollToTop } from '../ScrollToTop';

const ChangePlaid = ({
  handleContinue,
  setPlaidState,
  isEdit,
  handleSkipToNextSection,
  updateAndValidateProperty,
  closeTimes,
  setCloseTimes,
}) => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setLoading, appData } = useContext(UserContext);
  const oauth_state_id = cookie.load('oauth_state_id');
  const receivedRedirectUri = cookie.load('receivedRedirectUri');
  const enforcePlaid = !!TenantConfig?.manualBankAccount?.enforcePlaid;
  const plaidFeature = appData.applicationFeatures?.find(
    (feature) => feature.itemType === 'PlaidTokenProperty'
  );
  const financialFeature = appData.applicationFeatures?.find(
    (feature) => feature.itemType === 'FinancialInstrumentProperty'
  );

  const handleManualProcess = async () => {
    setPlaidState('manual');
    handleContinue();
  };

  // generate a link_token
  useEffect(() => {
    async function createLinkToken() {
      const res = await getPlaidLinkToken();
      setToken(res.data.linkToken);
      localStorage.setItem('link_token', JSON.stringify(res.data.linkToken));
    }

    if (oauth_state_id) {
      const linkTokenObj = localStorage.getItem('link_token');
      const linkToken = JSON.parse(linkTokenObj);
      setToken(linkToken);
    } else {
      createLinkToken();
    }
  }, []);

  return (
    <ScrollToTop>
      <div className="bank-information">
        <h1 className="title">Here is what you have</h1>
        <h3 className="subtitle">You have selected bank account</h3>
        <h3 className="subtitle">
          {plaidFeature &&
          plaidFeature.value &&
          plaidFeature.value?.plaidLinkage?.plaidNotLinkable == true
            ? `${financialFeature.value.bankAccountType} ending # ${financialFeature.value.maskedRoutingNumber}`
            : `${
                plaidFeature.value.financialInstruments[
                  plaidFeature.value.selectedFinancialInstrumentIndex
                ]?.associatedBankName
              } # ${
                plaidFeature.value.financialInstruments[
                  plaidFeature.value.selectedFinancialInstrumentIndex
                ]?.maskedAccountNumber
              }`}
        </h3>
        <div className="plaid-options">
          <div className="option-item">
            <button
              className="text-link-btn"
              onClick={() => {
                setPlaidState('success');
                handleContinue();
              }}
            >
              Select another Plaid account
            </button>

            <div>
              {token && (
                <CustomPlaidLink
                  closeTimes={closeTimes}
                  setCloseTimes={setCloseTimes}
                  token={token}
                  handleContinue={handleContinue}
                  setPlaidState={setPlaidState}
                  setLoading={setLoading}
                  setError={setError}
                  receivedRedirectUri={oauth_state_id ? receivedRedirectUri : undefined}
                  buttonText={'Start Plaid Again'}
                  buttonClassName={'plaid-btn'}
                />
              )}
            </div>

            {error && <div className="error-text">{error}</div>}
            <img src={plaidImg} className="plaid-img" alt="" />

            {isEdit && (
              <>
                <button onClick={() => navigate('/review')} className="text-link-btn bottom-link">
                  I changed my mind, I have no edits. Continue back to review page.
                </button>
                {!enforcePlaid && (
                  <button className="text-link-btn bottom-link" onClick={handleManualProcess}>
                    Don’t want to use Plaid? You can also sign up with our manual process.
                  </button>
                )}
              </>
            )}
          </div>
          <div className="d-flex bottom-actions align-items-center justify-content-around">
            <div className="actions d-flex">
              {!isEdit && !!TenantConfig?.settings?.isSaveAndContinueButtonEnabled ? (
                <button onClick={() => updateAndValidateProperty(true)} className="primary-btn">
                  Save and Continue Later
                </button>
              ) : (
                ''
              )}
              {!isEdit && (
                <button className="primary-btn" onClick={handleSkipToNextSection}>
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </ScrollToTop>
  );
};

export default ChangePlaid;
